export type GridPosition = {
  left: number;
  top: number;
  width: number;
  height: number;
};

function setTransform({ top, left, width, height }: Position): Object {
  // Replace unitless items with px
  const translate = `translate(${left}px,${top}px)`;
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: `${width}px`,
    height: `${height}px`,
    position: 'absolute',
  };
}

function setTopLeft({ top, left, width, height }: Position): Object {
  return {
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
    height: `${height}px`,
    position: 'absolute',
  };
}
function calcGridItemWHPx(
  gridUnits: number,
  colOrRowSize: number,
  marginPx: number,
): number {
  // 0 * Infinity === NaN, which causes problems with resize contraints
  if (!Number.isFinite(gridUnits)) return gridUnits;
  return Math.round(
    colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx,
  );
}

export function calcGridItemStyle(
  cols: number = 1,
  rows: number = 1,
  height: number,
  width: number,
  pos: GridPosition,
  margin: [number, number] = [0, 0],
  containerPadding: [number, number] = [0, 0],
): Object {
  const { x, y, w, h } = pos;
  const rowHeight = height / rows;
  const colWidth =
    (width - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
  const out = {
    width: calcGridItemWHPx(w, colWidth, margin[0]),
    height: calcGridItemWHPx(h, rowHeight, margin[1]),
    top: Math.round((rowHeight + margin[1]) * y + containerPadding[1]),
    left: Math.round((colWidth + margin[0]) * x + containerPadding[0]),
  };

  return setTransform(out);
}
